import { Link } from 'react-router-dom';
import { getSampleAssessmentGroupSolutionAssignmentUrl, Paths } from '../../../utils/routerUrls';

export const generateRGZsampleLink = (schoolId: string, rgzId: string, examinerId: string): JSX.Element => {
  return <Link to={getSampleAssessmentGroupSolutionAssignmentUrl(schoolId, rgzId, examinerId)}>{rgzId}</Link>;
};
